<template>
  <ResendExpiredLink
    :disabled="hasBeenSent"
    :loading="isLoading"
    :translations
    @click="handleResendLink"
  />
</template>

<script lang="ts" setup>
import ResendExpiredLink from '~/scopes/guest/components/ResendExpiredLink/ResendExpiredLink.vue'
import { useResendGuestLink } from '~/scopes/guest/composables/useResendGuestLink'
import translations from '~/scopes/guest/pages/guest-orders-resend-link/GuestOrdersResendLink.translations'

const { isLoading, hasBeenSent, handleResendLink } = useResendGuestLink(
  'guest_order_access',
  translations,
  'guest_orders_resend_link',
)
</script>
